/*
  TODO: [LATER] Unit price adjust on variant change
*/

class ProductCardForm extends HTMLElement {
  constructor() {
    super();

    this.variantsData = [];
    this.handleOptions.bind(this);
    this.handleATC.bind(this);
  }

  connectedCallback() {
    this.variantsData = this.getVariantsData();
    this.handleOptions();
    this.updateSelectedVariant();
    this.handleATC();
  }

  getVariantsData() {
    const variantsScript = this.querySelector('script[type="application/json"][data-product-variants]');
    if (!variantsScript) return [];

    try {
      const variantsData = JSON.parse(variantsScript.textContent || '[]');
      return Array.isArray(variantsData) ? variantsData : [];
    } catch (error) {
      console.error('Error parsing variants data:', error);
      return [];
    }
  }

  handleOptions() {
    const productOptions = this.querySelector('.product-options');
    if (!productOptions) return;
  
    productOptions.querySelectorAll('select, input').forEach((elem) => {
      elem.addEventListener('change', () => {
        this.updateSelectedVariant();
      });
    });
  }

  updateSelectedVariant() {
    const productOptions = this.querySelector('.product-options');
    if (!productOptions) return;

    const selectedOptions = [];

    productOptions.querySelectorAll('select, input').forEach((select) => {
      if (select.type === 'radio') {
        if (select.checked) {
          selectedOptions.push(select.value);
        }
      } else {
        selectedOptions.push(select.value);
      }
    });

    // console.log('Selected options:', selectedOptions);
    // console.log('All variants:', this.variantsData);

    const selectedVariant = this.variantsData.find((variant) => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });

    // console.log('Selected variant:', selectedVariant);

    const variantOptionsCount = this.variantsData[0]?.options.length || 0;
    const hasSelectedAllOptions = selectedOptions.length === variantOptionsCount && selectedOptions.every(Boolean);

    if (selectedVariant) {
      const hiddenInput = this.querySelector('input[type="hidden"][name="id"]');

      if (hiddenInput) {
        hiddenInput.value = selectedVariant.id;
      }

      const cardWrapper = this.closest('article');
      const image = cardWrapper.querySelector('.product-card-image img');
      const price = cardWrapper.querySelector('.price');
      const atcButton = this.querySelector('.shopify-product-form button[type="submit"]');
      const soldOutBadge = cardWrapper.querySelector('.badge-sold-out');
      const saleBadge = cardWrapper.querySelector('.badge-sale');
      const link = cardWrapper.querySelector('.product-card-link');

      if (image) {
        const image400 = selectedVariant.image_400
        const image800 = selectedVariant.image_800

        if (image400 && image800) {
          image.src = image800;
          image.srcset = `
            ${image400} 400w,
            ${image800} 800w
          `;
        }
      }

      if (price) {
        price.querySelectorAll('[data-price]').forEach((elem) => {
          elem.textContent = window.Shopify.formatMoney(selectedVariant.price);
        });
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          price.setAttribute('data-has-price-compare', 'true');
          price.querySelectorAll('[data-compare-price]').forEach((elem) => {
            elem.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price);
          });
        } else {
          price.setAttribute('data-has-price-compare', 'false');
          price.querySelectorAll('[data-compare-price]').forEach((elem) => {
            elem.textContent = '';
          });
        }
      }

      if (atcButton) {
        atcButton.disabled = !selectedVariant.available;
        atcButton.querySelector('.btn-text').textContent = selectedVariant.available
          ? window.theme.strings.product.addToCart
          : window.theme.strings.product.soldOut;
      }

      if (soldOutBadge) {
        soldOutBadge.hidden = selectedVariant.available;
      }

      if (saleBadge) {
        const saleBadgeType = saleBadge.getAttribute('data-sale-badge-type');
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          const saleValue = selectedVariant.compare_at_price - selectedVariant.price;
          if (saleBadgeType === 'amount') {
            saleBadge.textContent = `${window.theme.strings.product.saleBadge} ${window.Shopify.formatMoney(saleValue)}`;
          } else if (saleBadgeType === 'percentage') {
            const percentage = Math.round((saleValue / selectedVariant.compare_at_price) * 100);
            saleBadge.textContent = `${window.theme.strings.product.saleBadge} ${percentage}%`;
          }
          saleBadge.hidden = selectedVariant.available ? false : true;
        } else {
          saleBadge.textContent = '';
          saleBadge.hidden = true;
        }
      }

      if (link) {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', selectedVariant.id);
        link.href = url.toString();
      }
    } else if (hasSelectedAllOptions) {
      const hiddenInput = this.querySelector('input[type="hidden"][name="id"]');
      const atcButton = this.querySelector('.shopify-product-form button[type="submit"]');

      if (hiddenInput) {
        hiddenInput.value = '';
      }

      if (atcButton) {
        atcButton.disabled = true;
        atcButton.querySelector('.btn-text').textContent = window.theme.strings.product.unavailable || 'Unavailable';
      }
    }

    this.handleOptionsAvailability();
  }

  getSelectedOptionsByPosition(productOptions) {
    const selectedOptions = {};

    productOptions.querySelectorAll('[data-option-position]').forEach((elem) => {
      const position = Number(elem.dataset.optionPosition);
      if (!Number.isFinite(position) || position < 1) return;

      if (elem.type === 'radio' && !elem.checked) return;
      if (elem.tagName === 'SELECT' && elem.value === '') return;

      selectedOptions[position] = elem.value;
    });

    return selectedOptions;
  }

  isOptionValueAvailable(position, value, selectedOptions) {
    if (!value) return true;

    return this.variantsData.some((variant) => {
      if (!variant.available) return false;

      for (let index = 1; index <= 3; index += 1) {
        const optionValue = index === position ? value : selectedOptions[index];
        if (!optionValue) continue;

        if (variant.options[index - 1] !== optionValue) {
          return false;
        }
      }

      return true;
    });
  }

  handleOptionsAvailability() {
    const productOptions = this.querySelector('.product-options');
    if (!productOptions) return;

    const selectedOptions = this.getSelectedOptionsByPosition(productOptions);

    productOptions.querySelectorAll('input[data-option-position]').forEach((input) => {
      if (input.type === 'hidden') return;

      const position = Number(input.dataset.optionPosition);
      if (!Number.isFinite(position) || position < 1) return;

      const isAvailable = this.isOptionValueAvailable(position, input.value, selectedOptions);
      input.classList.toggle('disabled', !isAvailable);
      if (isAvailable) {
        input.removeAttribute('aria-disabled');
      } else {
        input.setAttribute('aria-disabled', 'true');
      }
    });

    productOptions.querySelectorAll('select[data-option-position]').forEach((select) => {
      const position = Number(select.dataset.optionPosition);
      if (!Number.isFinite(position) || position < 1) return;

      Array.from(select.options).forEach((option) => {
        if (option.value === '') return;

        const isAvailable = this.isOptionValueAvailable(position, option.value, selectedOptions);
        option.disabled = !isAvailable;
        option.classList.toggle('disabled', !isAvailable);
        if (isAvailable) {
          option.removeAttribute('aria-disabled');
        } else {
          option.setAttribute('aria-disabled', 'true');
        }
      });
    });

    const article = this.closest('article');
    if (!article) return;

    article.querySelectorAll('.product-card-color-swatches input[data-option-position]').forEach((input) => {
      const position = Number(input.dataset.optionPosition);
      if (!Number.isFinite(position) || position < 1) return;

      const isAvailable = this.isOptionValueAvailable(position, input.value, selectedOptions);
      input.classList.toggle('disabled', !isAvailable);
      if (isAvailable) {
        input.removeAttribute('aria-disabled');
      } else {
        input.setAttribute('aria-disabled', 'true');
      }
    });
  }

  async handleATC() {
    const form = this.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const submitter = event.submitter instanceof HTMLElement ? event.submitter : submitButton;

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('loading');

      try {
        const formData = new FormData(form);
        await window.ThemeCart.add(formData, { returnFocusTarget: submitter });
      } catch (error) {
        console.error('Error adding product to cart', error);
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.classList.remove('loading');
      }
    });
  }
}
customElements.define('product-card-form', ProductCardForm);


class ProductCardColorSwatches extends HTMLElement {
  constructor() {
    super();

    this.article = this.closest('article');
    this.handleSwatchChange = this.handleSwatchChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('change', this.handleSwatchChange);
    this.initCheckedSwatches();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleSwatchChange);
  }

  handleSwatchChange(event) {
    const input = event.target.closest('.color-swatches input[type="radio"]');
    if (!input || !this.contains(input)) return;

    this.updateProductImage(input);
    this.syncProductOptions(input.value);
  }

  initCheckedSwatches() {
    this.querySelectorAll('.color-swatches input[type="radio"]:checked').forEach((input) => {
      this.syncProductOptions(input.value);
    });
  }

  updateProductImage(input) {
    const productImg = this.article.querySelector('.product-card-img');
    if (!productImg) return;

    const image400 = input.getAttribute('data-variant-image-400');
    const image800 = input.getAttribute('data-variant-image-800');

    if (!image400 || !image800) return;

    productImg.src = image800;
    productImg.srcset = `
      ${image400} 400w,
      ${image800} 800w
    `;
  }

  syncProductOptions(value) {
    this.article.querySelectorAll('.product-options input[type="radio"]').forEach((input) => {
      if (input.value !== value) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.article.querySelectorAll('.product-options select').forEach((select) => {
      const optionToSelect = Array.from(select.options).find((option) => option.value === value);
      if (!optionToSelect) return;

      select.value = optionToSelect.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
customElements.define('product-card-color-swatches', ProductCardColorSwatches);
